<template>
  <v-card class="mx-auto my-4" max-width="1000" :rounded="false" outlined>
    <v-toolbar color="blue-grey darken-1" dark flat>
      <v-toolbar-title>{{ $t('admin.users') }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon :to="'/admin/users/_new'">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <div v-if="loading" class="text-center">
      <v-progress-circular class="my-10" indeterminate color="primary"></v-progress-circular>
    </div>
    <v-list v-else two-line>
      <v-list-item-group active-class="blue-grey--text">
        <template v-for="(user, index) in users">
          <v-list-item :key="user.name" @click="editItem(user)">
            <lean-list-item-content :record="user" :listConfig="listConfig">
              <template v-slot:actions>
                <div class="d-flex">
                  <v-tooltip
                    v-if="user.status === 'RESET_REQUIRED' || user.status === 'FORCE_CHANGE_PASSWORD'"
                    class="px-2"
                    bottom
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon>
                        <v-icon color="grey lighten-1">mdi-lock-reset</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('admin.reset.required') }}</span>
                  </v-tooltip>
                  <v-tooltip v-if="" class="px-2" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon>
                        <v-icon class="px-2" v-if="!user.enabled" color="grey lighten-1">mdi-account-off</v-icon>
                        <v-icon class="px-2" v-else color="grey lighten-1">mdi-account</v-icon>
                      </v-btn>
                    </template>
                    <span v-if="!user.enabled">{{ $t('admin.disabled') }}</span>
                    <span v-else>{{ $t('admin.enabled') }}</span>
                  </v-tooltip>
                </div>
              </template>
            </lean-list-item-content>
          </v-list-item>
          <v-divider v-if="index < users.length - 1" :key="index"></v-divider>
        </template>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
import LeanListItemContent from '@/components/LeanListItemContent.vue';

export default {
  name: 'LeanAdminUserList',
  components: {
    LeanListItemContent
  },
  data: function () {
    return {
      loading: true,
      users: [],
      listConfig: {
        title: 'name',
        subtitle: 'email'
      }
    };
  },
  async mounted() {
    await this.getUsers();
  },
  methods: {
    editItem(event) {
      this.$router.push({ path: `/admin/users/${event.name}` });
    },
    async getUsers() {
      this.loading = true;
      this.users = await this.$store.state.sdk.getUsers();
      this.loading = false;
    }
  }
};
</script>
